import axios from 'axios';

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000').replace(/\/+$/, '');
const API_URL = `${BACKEND_URL}/api/`;
const URL = `${BACKEND_URL}/`;

export const axiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true, // Importante para permitir cookies HttpOnly
});

// Instancia para rutas fuera de /api/ (ej: /admin/)
export const rootInstance = axios.create({
    baseURL: URL,
    withCredentials: true,
});

export default axiosInstance;

